import { indexData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function IndexSection() {
  const ref = useScrollReveal();
  return (
    <section id="index" ref={ref} className="reveal-section py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            按分类快速浏览，找到你想要的影视资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-foreground-50 transition-colors duration-300 flex-shrink-0">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground-900 text-sm mb-1">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-xs mb-2">
                    {item.desc}
                  </p>
                  <span className="inline-block text-xs text-accent-600 font-medium">
                    {item.count}
                  </span>
                </div>
                <div className="flex-shrink-0 flex items-center">
                  <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-accent-500 transition-colors text-lg"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}